import { render } from "./HeaderDashboard.vue?vue&type=template&id=27b8bdac&scoped=true&ts=true"
import script from "./HeaderDashboard.vue?vue&type=script&lang=ts"
export * from "./HeaderDashboard.vue?vue&type=script&lang=ts"

import "./HeaderDashboard.vue?vue&type=style&index=0&id=27b8bdac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b8bdac"]])

export default __exports__